Ext.define('SA.view.TableFactory', {
    singleton: true,

    createTable({containerEl, dragObservable, cellDelegate}) {
        var state = new SA.view.TableState(),
            autoScrollAmountPerAnimationFrame = 7,
            tableCmp = Ext.widget({xtype: 'table', renderTo: containerEl}),
            topHeader = tableCmp.down('#topHeader'),
            leftHeader =  tableCmp.down('#leftHeader'),
            body = tableCmp.down('#body'),
            renderer = new SA.view.TableRenderer({
                cellDelegate,
                corner: tableCmp.down('#corner'),
                borderSizes: new SA.view.TableBorderSizes({width: 1, height: 1}),
                verticalScrollbarCap: tableCmp.down('#verticalScrollbarCap'),
                horizontalScrollbarCap: tableCmp.down('#horizontalScrollbarCap'),
                getBodyScrollPosition: () => ({top: body.getScrollTop(), left: body.getScrollLeft()}),
                topHeaderRenderer: this.createSectionRenderer({sectionId: 'topHeader', sectionCmp: topHeader, cellDelegate}),
                leftHeaderRenderer: this.createSectionRenderer({sectionId: 'leftHeader', sectionCmp: leftHeader, cellDelegate}),
                bodyRenderer: this.createSectionRenderer({sectionId: 'body', sectionCmp: body, cellDelegate})
            }),
            loadMask = Ext.widget({xtype: 'load-mask', zIndex: 2, hidden: true, renderTo: containerEl, spinnerSize: 'medium'}),
            controller = new SA.view.TableController({state, renderer, topHeader, leftHeader, body, loadMask}),
            dragActivityFactory = new SA.view.TableDragActivityFactory({autoScrollAmountPerAnimationFrame, controller, topHeader, observable: dragObservable});

        topHeader.addDomEventListener('scroll', () => controller.onScrollTopHeader());
        leftHeader.addDomEventListener('scroll', () => controller.onScrollLeftHeader());
        body.addDomEventListener('scroll', () => controller.onScrollBody());

        topHeader.addDomEventListener('mousedown', ev => dragActivityFactory.createActivityForTopHeaderMouseDown(ev));

        return controller;
    },

    createSectionRenderer({sectionId, sectionCmp, cellDelegate}) {
        var scrollFillerCmp = sectionCmp.down('#scrollFiller'),
            scrollFrameEl = sectionCmp.down('#scrollFrame').el.dom;

        return new SA.view.TableSectionRenderer({sectionId, sectionCmp, scrollFillerCmp, scrollFrameEl, cellDelegate});
    }
});